// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"b260e672","298":"ae28e54d","453":"35a23acd","888":"a7791850"}[chunkId] + ".chunk.js";
};